import { RouteConfig } from 'vue-router';

const Home = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "Index" */ '@/views/Index');
const CheckoutAamaly = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "CheckoutAamaly" */ '@/views/Checkout/Aamaly/checkout');
const CheckoutAamalyV2 = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "CheckoutAamaly" */ '@/views/Checkout/AamalyV2/checkout');
const CheckoutAlrajhi = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "CheckoutAlrajhi" */ '@/views/Checkout/Alrajhi/checkout');
const Success = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "Success" */ '@/views/Success/success');
const Failed = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "Failed" */ '@/views/Failed/failed');
const Cancelled = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "Cancelled" */ '@/views/Cancelled/cancelled');
const AwaitingPayment = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "AwaitingPayment" */ '@/views/AwaitingPayment/awaitingPayment');
const UnderProcessing = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "AwaitingPayment" */ '@/views/UnderProcessing/underProcessing');

const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'home',
    component: Home,
  },
  {
    path: '/checkout-ar/:id',
    name: 'CheckoutAlrajhi',
    component: CheckoutAlrajhi,
    meta: {
      hideBreadcrumb: true,
    },
  },
  {
    path: '/v2/checkout-am/:id',
    name: 'CheckoutAamalyV2',
    component: CheckoutAamalyV2,
    meta: {
      hideBreadcrumb: true,
    },
  },
  {
    path: '/checkout-am',
    name: 'CheckoutAamaly',
    component: CheckoutAamaly,
    meta: {
      hideBreadcrumb: true,
    },
  },
  {
    path: '/success/:id',
    name: 'Success',
    component: Success,
    meta: {
      hideBreadcrumb: true,
    },
  },
  {
    path: '/failed/:id',
    name: 'Failed',
    component: Failed,
    meta: {
      hideBreadcrumb: true,
    },
  },
  {
    path: '/cancelled/:id',
    name: 'Cancelled',
    component: Cancelled,
    meta: {
      hideBreadcrumb: true,
    },
  },
  {
    path: '/awaiting-payment/:id',
    name: 'AwaitingPayment',
    component: AwaitingPayment,
    meta: {
      hideBreadcrumb: true,
    },
  },
  {
    path: '/under-processing/:id',
    name: 'UnderProcessing',
    component: UnderProcessing,
    meta: {
      hideBreadcrumb: true,
    },
  },
];

export default routes;
